import React from "react";
import { styled } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";
import ChangeLang from "./ChangeLanguage";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import { Colors } from "../Utility/Colors";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../ReduxTLK/features/User/LoginSlice";
import NotificationList from "../Notification/NotificationList";
import signalRService from "../../GlobalComponents/Utility/SignalRConnection";
import Logout from "./Logout";
import SpecialNotificationList from "../Notification/SpecialNotificationList";

export default function NavBarButtons() {
  const isAutoLogin = localStorage.getItem("iframeAutoLogin") === "true";
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationListOpen, setNotificationListOpen] = React.useState(false);

  const openNotificationList = (event) => {
    setAnchorEl(event.currentTarget);
    setNotificationListOpen(true);
  };
  
  const navigate = useNavigate();
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleLogout = () => {
    setAnchorEl(null);
    dispatch(logoutUser());
    signalRService?.connection?.stop();
    navigate("/");
  };

  return (
    <>
      {/* Using Stack for better spacing and alignment */}
      <Stack 
        direction="row" 
        spacing={2} 
        alignItems="center"
        sx={{
          padding: '8px 16px',
          height: '100%',
        }}
      >
        {/* Uncomment if you want to add language selector
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ChangeLang />
        </Box>
        */}

        
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SpecialNotificationList
            open={notificationListOpen}
            setNotificationListOpen={setNotificationListOpen}
            openNotificationList={openNotificationList}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <NotificationList
            open={notificationListOpen}
            setNotificationListOpen={setNotificationListOpen}
            openNotificationList={openNotificationList}
          />
        </Box>

        {!isAutoLogin && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Logout />
          </Box>
        )}
      </Stack>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            marginTop: '8px',
            borderRadius: '8px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <MenuItem 
          onClick={handleLogout}
          sx={{
            fontFamily: 'DM Sans',
            padding: '10px 20px',
            '&:hover': {
              backgroundColor: '#F4F7FE',
            }
          }}
        >
          Se déconnecter
        </MenuItem>
      </Menu>
    </>
  );
}